import React from 'react';
import { useDispatch } from 'react-redux';
import { searchFacetChange } from '../Actions/FacetedSearch.action';

const Checkbox = (props) => {
    const dispatch = useDispatch();
    return (<a className={'config-check' + (props.isChecked ? ' config-check--checked' : '') + (props.isSmall ? '' : ' config-check--big')} 
    onClick={() => props.isSearch ? dispatch(searchFacetChange(props.group, props.item)) : props.onClick(props.value, !props.isChecked)}>
    { props.isChecked &&
        <svg>
            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#checked"></use>
        </svg>
    }
    </a>)
}

export default Checkbox;